import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import i18next from 'i18next';
import api from '../../../actions/api';
import Metabase from './Metabase';
import { getCurrentRestaurant } from '../../../selectors';
import { hasSuperPermission } from '../../../helpers/permissions';

class RestaurantsMetabase extends Component {
    state = { metabaseUrl: null }

    componentDidMount() {
        if (this.props.restaurant.id) {
            api.restaurant.get(this.props.restaurant.id).metabase.get().then(({ data }) => this.setState({ ...data }));
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.restaurant.id !== prevProps.restaurant.id && this.props.restaurant.id) {
            api.restaurant.get(this.props.restaurant.id).metabase.get().then(({ data }) => this.setState({ ...data }));
        }
    }

    render() {
        if (!this.state.metabaseUrl) {
            if (!hasSuperPermission('operation')) return null;

            return (
                <div style={{ padding: 10 }}>
                    <Button onClick={() => api.restaurant.get(this.props.restaurant.id).metabase.set().then(({ data }) => this.setState({ ...data }))}>
                        Init reports
                    </Button>
                </div>
            );
        }

        return <Metabase iframeUrl={this.state.metabaseUrl} />;
    }
}

RestaurantsMetabase.propTypes = {
    restaurant: PropTypes.object,
};

const mapStateToProps = (state) => {
    const restaurant = getCurrentRestaurant(state);

    return { restaurant };
};

export default connect(mapStateToProps)(RestaurantsMetabase);
